<script>
  export default {
    name: "ButtonIcon",
    props: {
      icon: { type: String, required: true },
      variant: { type: String, default: "primary" },
      disabled: { type: Boolean, default: false },
    },
  };
</script>

<template>
  <button class="btn-icon" :class="`btn-icon--${variant}`" :disabled="disabled" @click="$emit('click')">
    <i :class="icon"></i>
  </button>
</template>

<style lang="scss" scoped>
  .btn-icon {
    border: none;
    border-radius: 6px;
    padding: 6px;
    cursor: pointer;
    color: white;
    width: 32px;
    height: 32px;
    @include Flex();
    &--primary {
      background: #007bff;
    }
    &--secondary {
      background: #6c757d;
    }

    &:disabled {
      cursor: not-allowed;
    }
  }
</style>
